import React from "react";
import { OrderTableFooterButton } from "../../common/Buttons";
import { AiOutlineClose } from "react-icons/ai";

function ModalSpecial(props) {
  return (
    <div className={"modal-wrapper"}>
      <div
        className={"modal-backdrop"}
        onClick={props.maskClosable === true ? () => props.onClose() : undefined}
      />

      <div
        className="modal-dialog modal-edit modal-editOrders"
        style={{ zIndex: 101, ...props.style }}
      >
        <div className="modal-content px-2 py-2" style={{ height: "100vh" }}>
          {(props.text || props.headerAction || props.hideClose !== true) && (
            <div className="col">
              <div className="d-flex w-100 align-items-center justify-content-between font-weight-bold modal-title text-orange text-xl">
                <span className="flex-grow-1">{props.text}</span>
                <span className="d-flex flex-shrink-0 align-items-center">
                  {props.headerAction && (
                    <span className="mr-2 d-flex align-items-center">
                      {props.headerAction}
                    </span>
                  )}
                  {props.hideClose !== true && (
                    <AiOutlineClose
                      className="pl-2 text-black cursor-pointer"
                      size={25}
                      onClick={() => props.onClose()}
                    />
                  )}
                </span>
              </div>
            </div>
          )}
          <div
            className="modal-body"
            style={{ height: "100vh", overflow: "auto" }}
          >
            {props.children}
          </div>
          {props.bottoms && (
            <div className="modal-footer justify-content-center">
              <OrderTableFooterButton
                color="#ee3624"
                text="Save"
                handleSave={props.handleSave}
              />

              <OrderTableFooterButton
                color="silver"
                text="Close"
                onClick={() => props.onClose()}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalSpecial;
